import Const from 'constants';
import Action from 'actions';

let Lineup = {
    setFilterPosition(value) {
        return {
            type: Const.USED_PLAYERS_SET_FILTER_POSITION,
            value,
        };
    },

    setFilterTier(value) {
        return {
            type: Const.USED_PLAYERS_SET_FILTER_TIER,
            value,
        };
    },

    setFilterShowDown(value) {
        return {
            type: Const.USED_PLAYERS_SET_FILTER_SHOWDOWN,
            value,
        };
    },

    setFilterSingleGame(value) {
        return {
            type: Const.USED_PLAYERS_SET_FILTER_SINGLE_GAME,
            value,
        };
    },
};

export default Object.assign(Action, Lineup);
